import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserAccountService } from '../global-services/user-account.service';
import { LanguageService } from '../global-services/language.service';

export const roleBasedGuard: CanActivateFn = async (
  next: ActivatedRouteSnapshot
) => {
  if (
    await inject(UserAccountService).checkUserRoleWithAsyncAwait()
  ) {
    return true;
  } else {
    let tenant = localStorage.getItem('tenant');
    const currentLang = inject(LanguageService).getCurrentLanguageCode();
    if (tenant) {
      inject(Router).navigate([`${currentLang}/admin-login/${tenant}`]);
    } else {
      inject(Router).navigate([`${currentLang}/no-tenant-fallback`]);
    }

    return false;
  }
};
